<template>
  <div>
    <validation-observer ref="generateBillRef">
      <b-form
        autocomplete="off"
        @submit.prevent="generateBill"
      >
        <b-row>
          <b-col
            md="12"
          >
            <validation-provider
              name="Distance"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Distance"
                label-for="end-trip-distance"
              >
                <b-input-group>
                  <b-form-input
                    id="end-trip-distance"
                    v-model="endData.distance"
                    type="number"
                    placeholder="Distance"
                  />
                  <b-input-group-append>
                    <b-input-group-text class="bg-transparent">
                      <b>KM</b>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
                <span class="text-danger absolute">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- <b-col md="6">
            <validation-provider
              name="Date"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Date"
                label-for="end-trip-date"
              >
                <b-form-datepicker
                  id="end-trip-date"
                  v-model="endDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col> -->
          <!-- <b-col md="6">
            <validation-provider
              name="Time"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Time"
                label-for="end-trip-time"
              >
                <b-form-timepicker
                  id="end-trip-time"
                  v-model="endTime"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col> -->
        </b-row>
        <b-col
          md="12"
          class="p-0"
        >
          <b-button
            block
            type="submit"
            variant="primary"
            :disabled="submitting || !endData.distance"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <span v-else>Generate Bill</span>
          </b-button>
        </b-col>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import {
  BButton, BRow, BCol, BFormInput, BForm, BFormGroup, BSpinner, BInputGroup, BInputGroupAppend, BInputGroupText,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BFormGroup,
    BForm,
    BFormInput,
    BButton,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
  },
  setup(_, ctx) {
    const tripId = ctx.root.$route.params.id
    const submitting = ref(false)
    const generateBillRef = ref(null)
    // const endDate = ref(null)
    // const endTime = ref(null)

    const endData = ref({
      distance: null,
      // endTime: null,
    })
    const generateBill = async () => {
      submitting.value = true
      const res = await axiosIns.post(`/trips/regenerate-bill/${tripId}`, {
        data: {
          distance: endData.value.distance,
        },
      })
      const isError = res?.data?.data?.status === 'error'
      submitting.value = false
      if (isError) {
        errorNotification('Bill already exists')
      } else {
        ctx.emit('refetch-bill')
        ctx.root.$bvModal.hide('regenerate-bill-modal')
      }
    }

    // watch([endDate, endTime], () => {
    //   if (endDate.value && endTime.value) {
    //     endData.value.endTime = new Date(`${endDate.value} ${endTime.value}`).toISOString()
    //   }
    // })
    return {
      required,
      generateBillRef,
      generateBill,
      submitting,
      endData,
    }
  },
}
</script>

  <style>

  </style>
